__turbopack_context__.v({
  "finePrint": "BlockIssueBriefGoals-module-scss-module__6Ika9a__finePrint",
  "goalsBlock": "BlockIssueBriefGoals-module-scss-module__6Ika9a__goalsBlock",
  "headline": "BlockIssueBriefGoals-module-scss-module__6Ika9a__headline",
  "headlineBlock": "BlockIssueBriefGoals-module-scss-module__6Ika9a__headlineBlock",
  "headlineWrapper": "BlockIssueBriefGoals-module-scss-module__6Ika9a__headlineWrapper",
  "imgWrapper": "BlockIssueBriefGoals-module-scss-module__6Ika9a__imgWrapper",
  "innerWrapper": "BlockIssueBriefGoals-module-scss-module__6Ika9a__innerWrapper",
});
